import {useTranslation} from 'react-i18next'
import {Skeleton} from '@/components/ui/skeleton'
import {StatCard} from '@/components/section-card'
import type {CarteraResumen} from '@/hooks/inci/cartera/use-cartera'
import {formatCopFull} from '@/lib/money'

/** «Pro sin suscripción» solo aparece si no es cero: es deuda heredada, nunca un estado normal. */
export function ResumenVitals({resumen, isLoading}: {resumen: CarteraResumen | undefined; isLoading: boolean}) {
  const {t} = useTranslation()

  if (isLoading && !resumen) {
    return (
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="cartera-resumen-loading">
        {Array.from({length: 4}).map((_, i) => (
          <Skeleton key={i} className="h-20 w-full" />
        ))}
      </div>
    )
  }

  if (!resumen) return null

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="cartera-resumen">
      <StatCard label={t('cartera.vitals.mrr')} value={formatCopFull(resumen.mrr_cop)} testId="cartera-vital-mrr" />
      <StatCard
        label={t('cartera.vitals.activas')}
        value={String(resumen.suscripciones_por_estado.activa)}
        testId="cartera-vital-activas"
      />
      <StatCard
        label={t('cartera.vitals.vencidas')}
        value={String(resumen.facturas_vencidas)}
        testId="cartera-vital-vencidas"
      />
      <StatCard
        label={t('cartera.vitals.degradadasMes')}
        value={String(resumen.degradadas_mes)}
        testId="cartera-vital-degradadas"
      />
      {resumen.paid_sin_suscripcion > 0 && (
        <StatCard
          label={t('cartera.vitals.paidSinSuscripcion')}
          value={String(resumen.paid_sin_suscripcion)}
          testId="cartera-vital-paid-sin-suscripcion"
          alert
        />
      )}
    </div>
  )
}
